import {Component} from 'react'
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'

import ConfirmRegistrationForm from '../../components/Forms/ConfirmRegistrationForm/ConfirmRegistrationForm.jsx'
import PageLayout from '../Layout/PageLayout.jsx'
import SubmitButton from '../../components/Forms/ConfirmRegistrationForm/SubmitButton.jsx'
import redirectPostLogin from '../../services/redirectPostLogin.js'
import {generate} from '../../routes.js'
import submit from '../../components/Forms/RegisterForm/submit.js'

class ConfirmRegistration extends Component {
  onSubmitSuccess = (result) => {
    redirectPostLogin(result.data)
  }

  render() {
    const {currentUser, universes} = this.props

    if (currentUser && !currentUser.id) {
      return (
        <PageLayout>
          <div className="">
            <h1 className="text-center">Finalisez votre inscription</h1>
            <ConfirmRegistrationForm
              currentUniverseId={this.props.currentUniverseId}
              onSubmit={(values) => submit({...values, ...this.props.currentUser})}
              onSubmitSuccess={this.onSubmitSuccess}
              universes={universes}
            />
            <div className="text-center">
              <SubmitButton className="btn btn-primary my-3">S'enregistrer</SubmitButton>
            </div>
          </div>
        </PageLayout>
      )
    }

    return <Redirect to={generate({name: 'homepage'})}/>
  }
}

export default connect(
  (state) => ({
    currentUniverseId: state?.universe.currentUniverse.id ?? null,
    currentUser: state.currentUser.user,
    universes: state.universe.universes
  })
)(ConfirmRegistration)